<template>
  <div class="document-credit-inquiry">
    <DocumentTitle activeClass="mb-5">채권양도승낙서 및 위임장</DocumentTitle>
    <div class="content">
      <div class="mb-7">
        (주)펀다에이아이 귀중<br />본인은 본 계약서에 의하여 귀사가 본인에 대해서 가지고 있는 금전채권 및 계약상 
        본인에 대하여 갖는 일체의 권리(계약해제권을 포함한 계약자로서 갖는 모든 권리 (이하 ‘본건여신거래채권이라함))를 
        귀사가     년    월    일(이하 ‘양수인’이라함)        에게 채권매각을 위하여 양도함에 아무런 이의 없이 승낙합니다. 
        이와 관련하여 본인은 귀사가 본인을 대리하여 승낙할 수 있는 권한(위 양도관련 백지부분을 보충할 수 있는 권한을 포함)을 위임합니다.
      </div>
      <div class="mb-7">
        단, 본건 여신거래채권의 이자 및 원금은 양수인이 별도 서면청구에 기재된 방법에 따라 본건 여신거래채권의 이자 및 원금은 
        양수인이 별도 서면 청구에 기재된 방법에 따라 본건 여신거래채권의 이자 및 원금을 양수인에게 직접 납입 하도록 하겠습니다. 
        또한, 본인은 귀사가 본인으로부터 취득한 상기 개인신용정보를 채권의 양도에 따라 양수인으로부터 채권 추심등의 업무를 
        위탁 받은자에게 제공되는 것에 대해서도 이의 없이 동의합니다.
      </div>
    </div>

    <v-row no-gutters class="agree mt-3">
      <v-col cols="9">
        <p class="mb-0">채권양도 승낙과 위임에 대한 내용을</p>
      </v-col>

      <v-col cols="3" class="text-right">
        <button @click="isAgreed = !isAgreed" :class="{ active: isAgreed }">확인함</button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DocumentTitle from '@/components/documents/DocumentTitle.vue'

export default {
  components: {
    DocumentTitle,
  },
  data() {
    return {
      isAgreed: false,
    }
  },
  watch: {
    isAgreed(v) {
      this.$emit('emitAgreed', v)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.document-credit-inquiry {
  .content > div {
    line-height: 1.5;
  }

  .credit-inquiry-title {
    font-weight: bold;
    margin-bottom: 5px;
  }
}
</style>
